import React from 'react';
import PropTypes from 'prop-types';

import {Box} from 'views/components';

import {Translate} from 'views/module';

const NotificationStatusTag = (props) => {
  const {userNotificationEmail} = props;
  if (!userNotificationEmail) {
    return (
      <Box
        component="span"
        sx={{
          px: 1,
          py: 0.25,
          bgcolor: 'error.main',
          color: 'white',
          borderRadius: 3,
          fontSize: '12px',
          display: 'inline-flex',
          alignItems: 'center',
        }}
      >
        <Translate expression='client.ClientDetail.Relationships.Notification.NotSubscribed' />
      </Box>
    );
  } else {
    return (
      <Box
        component="span"
        sx={{
          px: 1,
          py: 0.25,
          bgcolor: 'success.main',
          color: 'white',
          borderRadius: 3,
          fontSize: '12px',
          display: 'inline-flex',
          alignItems: 'center',
        }}
      >
        <Translate expression='client.ClientDetail.Relationships.Notification.Subscribed' />
      </Box>
    );
  }
};

NotificationStatusTag.propTypes = {
  userNotificationEmail: PropTypes.string,
};

export default React.memo(NotificationStatusTag);
